<div class="row gy-3">
  <div class="col-md-8">
    <div class="border mb-3 mx-0">
      <div class="flex-fill p-3 bg-light fw-bold notranslate">Issue ID</div>
      <div class="flex-fill p-3 text-break notranslate">{{ entry.errorId || "-" }}</div>
    </div>
    <div class="row gx-3">
      <div class="col-md-6">
        <div class="d-flex flex-column mb-3">
          <div class="d-flex flex-column border mx-0 mb-3">
            <div class="flex-fill p-3 bg-light fw-bold notranslate">Error message</div>
            <div class="flex-fill p-3 text-break notranslate">{{ entry.errorDetails.errorMessage || "-" }}</div>
          </div>
          <div class="d-flex flex-column border mx-0">
            <div class="flex-fill p-3 bg-light fw-bold notranslate">Error</div>
            <div class="flex-fill p-3 text-break notranslate">
              <a [href]="getKibanaUrl(entry.errorDetails.error)" target="_blank">{{ entry.errorDetails.error || "-" }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="d-flex flex-column mb-3">
          <div class="d-flex border row mx-0 mb-3">
            <div class="col-3 flex-fill p-3 bg-light fw-bold notranslate">Level</div>
            <div class="col flex-fill p-3 notranslate">{{ formattedLevel || "-" }}</div>
          </div>
          <div class="d-flex border row mx-0">
            <div class="col-3 flex-fill p-3 bg-light fw-bold notranslate">Message</div>
            <div class="col flex-fill p-3 text-break notranslate">{{ entry.errorDetails.message || "-" }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="border d-flex mx-0">
      <div class="overflow-auto w-100">
        <div class="row bg-light fw-bold p-3">
          <div class="col-auto notranslate">
            Stack trace
          </div>
          <div class="col-auto ms-auto">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="applicationOnly"
                     [value]="isFullStackTraceDisplayed" (click)="toggleStackTrace()">
              <label class="form-check-label" for="applicationOnly">Application only</label>
            </div>
          </div>
        </div>
        <div class="col flex-fill p-3 notranslate stack-trace">
          {{ isFullStackTraceDisplayed ? entry.errorDetails.stackTrace : getStackTrace() }}
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="row gy-3">
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Message Index</div>
          <div class="flex-fill p-3 text-break notranslate">
            <a [href]="getKibanaUrl(entry.errorMetadata.messageIndex)" target="_blank">
              {{ entry.errorMetadata.messageIndex || "-" }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Message ID</div>
          <div class="flex-fill p-3 text-break notranslate">
            <a [href]="getKibanaUrl(entry.errorMetadata.messageId)" target="_blank">
              {{ entry.errorMetadata.messageId || "-" }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Invocation ID</div>
          <div class="flex-fill p-3 text-break notranslate">
            <a [href]="getKibanaUrl(entry.errorMetadata.invocationId)" target="_blank">
              {{ entry.errorMetadata.invocationId || "-" }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Correlation ID</div>
          <div class="flex-fill p-3 text-break notranslate">
            <a [href]="getKibanaUrl(entry.errorMetadata.correlationId)" target="_blank">
              {{ entry.errorMetadata.correlationId || "-" }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Trace ID</div>
          <div class="flex-fill p-3 text-break notranslate">
            <a [href]="getKibanaUrl(entry.errorMetadata.traceId)" target="_blank">
              {{ entry.errorMetadata.traceId || "-" }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Client ID</div>
          <div class="flex-fill p-3 text-break notranslate">
            <a [href]="getKibanaUrl(entry.errorMetadata.clientId)" target="_blank">
              {{ entry.errorMetadata.clientId || "-" }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Trace Element</div>
          <div class="flex-fill p-3 text-break notranslate">
            <a [href]="getKibanaUrl(entry.errorMetadata.traceElement)" target="_blank">
              {{ entry.errorMetadata.traceElement || "-" }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Logger name</div>
          <div class="flex-fill p-3 text-break notranslate">
              <a [href]="getKibanaUrl(entry.errorDetails.loggerName)"
                 target="_blank">{{ entry.errorDetails.loggerName || "-" }}</a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Trigger</div>
          <div class="flex-fill p-3 text-break notranslate">
            <a [href]="getKibanaUrl(entry.errorDetails.trigger)" target="_blank">
              {{ entry.errorDetails.trigger || "-" }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Trigger type</div>
          <div class="flex-fill p-3 text-break notranslate">
            {{ entry.errorDetails.triggerType || "-" }}
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Consumer</div>
          <div class="flex-fill p-3 text-break notranslate">
            <a [href]="getKibanaUrl(entry.errorMetadata.consumer)" target="_blank">
              {{ entry.errorMetadata.consumer || "-" }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Message Template</div>
          <div class="flex-fill p-3 text-break notranslate">
            <a [href]="getKibanaUrl(entry.errorDetails.messageTemplate)" target="_blank">
              {{ entry.errorDetails.messageTemplate || "-" }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Sequence</div>
          <div class="flex-fill p-3 text-break notranslate">{{ entry.sequence || "-" }}</div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Application</div>
          <div class="flex-fill p-3 text-break notranslate">
            <a [href]="getKibanaUrl(entry.errorDetails.application)" target="_blank">
              {{ entry.errorDetails.application || "-" }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate">Environment</div>
          <div class="flex-fill p-3 text-break notranslate">{{ formattedEnvironment || "-" }}</div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column border">
          <div class="flex-fill p-3 bg-light fw-bold notranslate ">Version ID</div>
          <div class="flex-fill p-3 text-break notranslate ">{{ entry.errorMetadata.versionId || "-" }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
